export default __webpack_public_path__ + "files/1a631171861d33aae580da340ce68cdb.mp3";